import { Checks, Copy, WarningCircle, X } from "@phosphor-icons/react";
import React from "react";
import dayjs from "dayjs"; // Use for date/time formatting
import { formatHotel } from "../../api/hotelTime";
 
const ConferenceRoomModal = ({requestData,setRequestType,setOpenRequestModal,setRequestData}) => {
  
    // Format the date and time
    const tripDate = formatHotel(requestData.preferred_time, "DD MMMM YYYY");
    const tripTime = formatHotel(requestData.preferred_time, "hh:mm A");


    // Close Modal
    const closeModal=()=>{
        try{
            setOpenRequestModal(false);
            setRequestType("");
            setRequestData(null);
            
        }catch(error){
            console.log(error);
        }
    }

    // console.log("Data of Cab : ",requestData);

    return (
        <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
           
            <div
                className="popup-content bg-white p-6 rounded-lg text-sm flex flex-col gap-2 w-[80%] md:w-[70%] lg:w-[50%]">
                
                {/*  Request Header */}
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-semibold">Conference Room Request</h2>
                    <button
                        className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                        type="button"
                        onClick={()=>closeModal()}
                    >
                        <X weight="bold" size={18} />
                    </button>
                </div>

                <div className="flex flex-col gap-4">

                    {/* Room Details */}
                    <div className="flex items-center justify-between">
                 
                        <div className="w-1/3">
                            <p className="text-[#8C9199] mb-2">
                                Conference Room Number
                            </p>
                            <div className="flex items-center gap-2">
                                <p
                                    className="truncate w-[70%]"
                                >
                                    {
                                        requestData?.conference_room_number || "room number"
                                    }
                                </p>
                            </div>
                        </div>
                                
                        {requestData.preferred_time && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">Request Date</p>
                                <p>{tripDate}</p>
                            </div>
                        }

                        {requestData.preferred_time && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">
                                    Request Time
                                </p>
                                <p>{tripTime}</p>
                            </div>
                        }
                    </div>

                    {/* Conference Room */}
                    <div className="flex items-center justify-between">
                                
                        {requestData.number_of_people && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">Number of People</p>
                                <p>{requestData?.number_of_people || ""}</p>
                            </div>
                        }

                        {requestData.duration_hours && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">Duration Hour</p>
                                <p>{requestData?.duration_hours || ""}</p>
                            </div>
                        }
                    </div>

                    {/* total_amount */}
                    <div className="flex">
                        {requestData?.total_amount && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199]">Fees</p>
                                <input
                                    type="text"
                                    value={requestData?.total_amount || ""}
                                    placeholder="Amount"
                                    className="px-2 py-1.5 border-[1.5px] rounded-md mt-1"
                                    disabled
                                />
                            </div>
                        }
                    </div>
                    
                    {/* Comments */}
                    {requestData?.additional_comments && 
                        <div>
                            <p className="text-[#8C9199] mb-1">Additional Comments</p>
                            <textarea
                                value={requestData?.additional_comments || ""}
                                rows={4}
                                className="w-full border-[1.5px] rounded-md p-2"
                                placeholder="Please leave your remarks here"
                                disabled
                            ></textarea>
                        </div>
                    }

                    
                    {/* Remarks */}
                    {requestData?.remarks && 
                        <div>
                            <p className="text-[#8C9199] mb-1">Remarks</p>
                            <textarea
                                value={requestData?.remarks || ""}
                                rows={4}
                                className="w-full border-[1.5px] rounded-md p-2"
                                placeholder="Please leave your remarks here"
                                disabled
                            ></textarea>
                        </div>
                    }

                </div>
                
            </div>
   

        </div>
    );
};

export default ConferenceRoomModal;
